export const TYPE_SELECTED = 'SELECTED ITEM';
export const TYPE_ERROR = 'ERROR TRANSACTION';
export const TYPE_CLOSE = 'CLOSE MODAL';
export const TYPE_FILTER = 'FILTER ITEM';
